const CANDIDATE_APPLICATION_STATUS = {
    'Holder': 'Convocado',
    'WaitingList': 'Lista de Espera'
}

export default CANDIDATE_APPLICATION_STATUS